import React from "react";

export default function Indicator(props) {
  return <div className="Indicator" style={props.style}>{props.text}</div>;
}